import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useSafeArea } from '../hooks/useSafeArea';

const SafeAreaTest = () => {
  const safeAreaInsets = useSafeArea();

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Safe Area Test
      </Typography>
      
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="body2" gutterBottom>
          Safe Area Insets:
        </Typography>
        <Typography variant="body2">
          Top: {safeAreaInsets.top}px
        </Typography>
        <Typography variant="body2">
          Bottom: {safeAreaInsets.bottom}px
        </Typography>
        <Typography variant="body2">
          Left: {safeAreaInsets.left}px
        </Typography>
        <Typography variant="body2">
          Right: {safeAreaInsets.right}px
        </Typography>
      </Paper>

      <Box className="safe-area-top" sx={{ bgcolor: 'primary.main', p: 2, mb: 2 }}>
        <Typography variant="body2" color="white">
          Top Safe Area Test (should have padding-top)
        </Typography>
      </Box>

      <Box className="safe-area-bottom" sx={{ bgcolor: 'secondary.main', p: 2, mb: 2 }}>
        <Typography variant="body2" color="white">
          Bottom Safe Area Test (should have padding-bottom)
        </Typography>
      </Box>

      <Box className="safe-area-all" sx={{ bgcolor: 'success.main', p: 2 }}>
        <Typography variant="body2" color="white">
          All Safe Areas Test (should have padding on all sides)
        </Typography>
      </Box>
    </Box>
  );
};

export default SafeAreaTest; 